module.exports = __webpack_public_path__ + "img/fashion_95.8775d3a5.jpg";